import { j as jwtDecode } from '../index-QrdBfapu.js';
import { getCookie, setCookie, removeCookie } from './cookies.js';
import { C as COOKIE_TOKEN_NAME, s as COOKIE_TOKEN_MAX_AGE_SEC } from '../cookies-l-jEMp6P.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-5CMab_Gs.js';
import './isBot.js';

const getToken = (ctx) => String(getCookie(COOKIE_TOKEN_NAME, ctx) || '');
const setToken = (token) => {
    setCookie(COOKIE_TOKEN_NAME, token, { maxAge: COOKIE_TOKEN_MAX_AGE_SEC });
};
const removeToken = (ctx) => {
    removeCookie(COOKIE_TOKEN_NAME, ctx);
};
const isAuthenticated = (ctx) => Boolean(getToken(ctx));
const isTokenExpired = (token) => {
    let decodedToken;
    try {
        decodedToken = jwtDecode(token);
    }
    catch (e) {
        return true;
    }
    const expirationTime = decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.exp;
    if (!expirationTime)
        return true;
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    return expirationTime < currentTimeInSeconds;
};

export { getToken, isAuthenticated, isTokenExpired, removeToken, setToken };
//# sourceMappingURL=auth.js.map
